import { Controller } from "@hotwired/stimulus"
import { DeviceDetection } from "../lib/device_detection"

// Connects to data-controller="pwa-aware"
export default class extends Controller {
  static values = {
    mode: String,        // 'show', 'hide', or 'pwa-mobile-or-desktop' when in PWA mode
    mobile: String       // 'show' or 'hide' when on mobile (separate from PWA)
  }

  connect() {
    this.updateVisibility()
  }

  async updateVisibility() {
    const DeviceDetection = (await import('../lib/device_detection')).DeviceDetection
    const isPWA = DeviceDetection.isPWA()
    const isMobile = DeviceDetection.isMobileDevice()

    let shouldHide = false

    // Handle PWA mode
    if (this.modeValue === 'hide' && isPWA) {
      shouldHide = true
    } else if (this.modeValue === 'show' && !isPWA) {
      shouldHide = true
    } else if (this.modeValue === 'pwa-mobile-or-desktop') {
      // Show when (PWA AND mobile) OR (desktop browser)
      // Hide when mobile but NOT PWA
      if (isMobile && !isPWA) {
        shouldHide = true
      }
    }

    // Handle mobile mode (separate from PWA)
    if (this.mobileValue === 'hide') {
      // Hide when NOT mobile OR when in PWA
      if (!isMobile || isPWA) {
        shouldHide = true
      }
    } else if (this.mobileValue === 'show') {
      // Show only when mobile AND not in PWA
      if (!isMobile || isPWA) {
        shouldHide = true
      }
    }

    if (shouldHide) {
      this.element.classList.add('hidden')
    } else {
      this.element.classList.remove('hidden')
    }
  }
}
